import React from 'react';
import PetAvatar from '../../components/PetAvatar/PetAvatar';
import styles from './Devices.module.scss';

interface PetNameCellProps {
  name: string;
  /** Server-resized (~96px) photo URL, or null to show the paw placeholder. */
  photoThumbUrl: string | null;
}

/**
 * A pet's name preceded by a small round photo thumbnail (or a paw placeholder
 * when there's no photo). Shared by the device/adoption tables. The image is
 * lazy-loaded, so only rows scrolled into view fetch their thumbnail — the
 * heavier drained/sort-all lists never download off-screen images.
 */
export default function PetNameCell({ name, photoThumbUrl }: PetNameCellProps) {
  return (
    <div className={styles.petNameCell}>
      <PetAvatar
        photoThumbUrl={photoThumbUrl}
        fallback={<span aria-hidden="true">🐾</span>}
        className={styles.petAvatar}
        imgClassName={styles.petAvatarImg}
      />
      <span>{name}</span>
    </div>
  );
}
